import { handleAction } from 'redux-actions';

import * as actions from '../actions';

const InitialState = {
  Records: [],
  PageSize: 1,
  PageNumber: 1,
  TotalCount: 0,
  TotalPages: 0,
};

export const influencerListReducer = handleAction(
  actions.setInfluencers,
  (state, { payload: influencers }) => influencers,
  InitialState
);
